import type { SolanaNftId } from './types'

type CreateSolanaAddressIdParameters = {
  readonly address: string
}

export const createSolanaAddressId = ({
  address,
}: CreateSolanaAddressIdParameters): `solana_${string}` =>
  `solana_address_${address}`

type CreateSolanaActionSourceParameters = {
  readonly signature: string
}

export const createSolanaActionSource = ({
  signature,
}: CreateSolanaActionSourceParameters): `solana_${string}` =>
  `solana_${signature}`

type CreateSolanaTokenAssetIdParameters = {
  readonly address: string
}

export const createSolanaTokenAssetId = ({
  address,
}: CreateSolanaTokenAssetIdParameters): SolanaNftId => `solana_${address}`

export const isSolanaNftId = (id: string): id is SolanaNftId =>
  id.startsWith('solana_')
